import { useTheme } from "@mui/material/styles";
import { Grid, Box, Typography, Link } from "@mui/material";
import packageJson from "../../package.json";

const Footer = (): JSX.Element => {
  const theme = useTheme();
  const appVersion = packageJson.version;

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Box sx={{ marginBottom: "20px", textAlign: "center" }}>
          <Typography
            align="center"
            variant="subtitle2"
            color={theme.palette.text.secondary}
            sx={{ marginTop: "25px", marginBottom: "0" }}
          >
            Copyright &copy; {new Date().getFullYear()} Make a Memory Family
          </Typography>

          {/* Links Section */}
          <Box sx={{ marginTop: "5px" }}>
            <Link
              href="/"
              color="inherit"
              sx={{ margin: "0 10px", fontSize: "0.8rem" }}
              underline="hover"
            >
              Home
            </Link>
            <Link
              href="/about-us"
              color="inherit"
              sx={{ margin: "0 10px", fontSize: "0.8rem" }}
              underline="hover"
            >
              About Us
            </Link>
            <Link
              href="/contact-us"
              color="inherit"
              sx={{ margin: "0 10px", fontSize: "0.8rem" }}
              underline="hover"
            >
              Contact Us
            </Link>
            <Link
              href="/faq"
              color="inherit"
              sx={{ margin: "0 10px", fontSize: "0.8rem" }}
              underline="hover"
            >
              FAQs
            </Link>
            <Link
              href="/privacy-policy"
              color="inherit"
              sx={{ margin: "0 10px", fontSize: "0.8rem" }}
              underline="hover"
            >
              Privacy Policy
            </Link>
          </Box>

          {/* Version Info */}
          <Typography
            align="center"
            variant="caption"
            color={theme.palette.text.secondary}
            sx={{ fontSize: "0.7rem", marginTop: "2px" }}
          >
            v{appVersion}
          </Typography>
        </Box>
      </Grid>
    </Grid>
  );
};

export default Footer;
